<ng-container *ngIf="event$ | async as event">
    <div class="page-container page-container-vertical">
        <isav-unpublished-warning
            [published]="!event.draft"
            contentName="Event"
            myContentPath="my-events"
        ></isav-unpublished-warning>
        <isav-notes *isavAuthenticated="true" [iri]="event['@id']"></isav-notes>
        <isav-add-note [(hidden)]="hidden" [contentIri]="event['@id']"></isav-add-note>
        <isav-action-title [title]="event.title | isavTitleFallback : event['@id']">
            <a *isavHasEditAccess="event['@id']" [isavEditLink]="event" isavBtn color="primary">
                Edit
            </a>
            <button
                (click)="hidden = false"
                *isavAuthenticated="true"
                type="button"
                isavBtn
                color="primary"
            >
                Write note
            </button>
            <button isavBtn color="primary" isavPrintPage>Print page</button>
        </isav-action-title>
    </div>
    <isav-content-type-view>
        <isav-caption> Data Information </isav-caption>
        <div isavContentTypeDetails>
            <p>
                <strong>Activity:&nbsp;</strong>
                <span>
                    <isav-taxonomies-names [iris]="[event.activity]"></isav-taxonomies-names>
                </span>
            </p>
            <p>
                <strong>Location:&nbsp;</strong>
                <span>{{ event.location }}</span>
            </p>
            <p>
                <strong>Attachments:&nbsp;</strong>
                <isav-files-link [iris]="event.attachments"></isav-files-link>
            </p>
            <p>
                <strong>Topics:&nbsp;</strong>
                <span>
                    <isav-taxonomies-names [iris]="event.topics"></isav-taxonomies-names>
                </span>
            </p>
            <p>
                <strong>Dates:&nbsp;</strong>
            </p>
            <p *ngFor="let time of event.startEndDates">
                {{ time.startDate | isavDate }}&nbsp;-&nbsp;{{ time.endDate | isavDate }}
            </p>
            <h2 class="title is-1 mt-6">Event details</h2>
            <isav-description-display
                [title]="event.title || ''"
                [content]="event.description"
            ></isav-description-display>
        </div>
        <div isavContentTypeAside>
            <isav-contact-information
                [contactName]="event.contactName"
                [contactEmail]="event.contactEmail"
                [contactPhone]="event.contactPhone"
            ></isav-contact-information>
            <img
                *ngIf="event.coverImage"
                [isavApiImg]="event.coverImage"
                alt=""
                aria-hidden="true"
                class="is-fullwidth is-containing is-max-vh"
            />
            <isav-image-caption [iri]="event.coverImage"></isav-image-caption>
        </div>
    </isav-content-type-view>

    <isav-page-content>
        <isav-domain-event-journal-list [iri]="event['@id']"></isav-domain-event-journal-list>
    </isav-page-content>
</ng-container>
